import React from "react";
import { HiOutlineShoppingBag } from "react-icons/hi";

import DoSeeListPage from "../../../layout/DoSeeListPage";
import type { Column } from "../../../ui";
import { _TYPES_ } from "../utils/types";
import { pushOneProduct } from "../../../lib/sysNavigation/SysNavigation";

type ProductRow = {
  product_id: number | string;
  name?: string;
  category?: string;
  price?: number | string;
  [key: string]: unknown;
};

const extraColumns: Column<ProductRow>[] = [
  {
    header: "Category",
    cell: (row) => (
      <span className="text-gray-600">{row.category ?? "—"}</span>
    ),
  },
  {
    header: "Price",
    cell: (row) => (
      <span className="text-gray-900">{row.price ?? "—"}</span>
    ),
  },
];

const Overview: React.FC = () => (
  <DoSeeListPage<ProductRow>
    type={_TYPES_.PRODUCT}
    title="Products"
    subtitle="Products sold or promoted on the public site."
    icon={<HiOutlineShoppingBag className="h-5 w-5" />}
    addRoute="/data/product/add"
    editRoute="/data/product/edit"
    pushOne={pushOneProduct}
    dataKey="products"
    countKey="productsCount"
    idField="product_id"
    titleField="name"
    searchFields={["name"]}
    extraColumns={extraColumns}
    simpleCrud
  />
);

export default Overview;
